import * as tiff from 'tiff';

const TiffToPngDataUrl = (fileData: ArrayBuffer): string => {
  var decodedData = tiff.decode(fileData, { onlyFirst: true });

  var canvas = document.createElement('canvas');
  canvas.width = decodedData[0].width;
  canvas.height = decodedData[0].height;

  var ctx = canvas.getContext('2d');
  var imgData = ctx!.createImageData(decodedData[0].width, decodedData[0].height);

  if (decodedData[0].alpha) {
    imgData.data.set(decodedData[0].data);
  } else {
    var dataWithAlpha = [];

    for (let i = 0; i < decodedData[0].size; i++) {
      dataWithAlpha[i * 4] = decodedData[0].data[i * 3];
      dataWithAlpha[i * 4 + 1] = decodedData[0].data[i * 3 + 1];
      dataWithAlpha[i * 4 + 2] = decodedData[0].data[i * 3 + 2];
      dataWithAlpha[i * 4 + 3] = 255;
    }

    imgData.data.set(dataWithAlpha);
  }

  ctx!.putImageData(imgData, 0, 0);

  return canvas.toDataURL();
};

export { TiffToPngDataUrl };
